// PhoneInputComponent.tsx
import React from "react";
import styles from "./PhoneInputComponent.module.css";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css"; // don't remove - this is default css

const PhoneInputComponent = ({
  value,
  onChange,
  placeholder = "Enter phone number",
  defaultCountry = "IN",
}) => {
  return (
    <PhoneInput
      international
      defaultCountry={defaultCountry}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={styles.phoneInput}
    />
  );
};

export default PhoneInputComponent;
